import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { LoadMore } from "../../../../components/LoadMore";
import { useTranslations } from "../../../../providers/useTranslations";
import { useStoreLocatorContext } from "../../hooks";
import { getStoreDetailsPageUrl } from "../../utils";
import { StoreLocatorCardV2 } from "../StoreLocatorCardV2";
import styles from "./StoreLocatorMobileList.module.scss";
const DEFAULT_PAGE_SIZE = 8;
const DEFAULT_PAGE = 1;
export const StoreLocatorMobileList = ({ pageSize = DEFAULT_PAGE_SIZE }) => {
    const { __ } = useTranslations();
    const [page, setPage] = useState(DEFAULT_PAGE);
    const { flotiqStores, storeDetailsPage, isOpeningHoursEnabled, isOpeningHoursBreaksEnabled, isAvailableDevicesEnabled, isAvailableSticksEnabled, } = useStoreLocatorContext();
    useEffect(() => {
        setPage(DEFAULT_PAGE);
    }, [flotiqStores]);
    const stores = useMemo(() => {
        return flotiqStores.slice(0, pageSize * page);
    }, [flotiqStores, page]);
    const hasMoreStores = stores.length < flotiqStores.length;
    return (_jsxs("div", { children: [_jsx("ul", { className: styles.list, children: stores.map((store) => {
                    const storeDetailsPageUrl = getStoreDetailsPageUrl(storeDetailsPage, store, isOpeningHoursEnabled, isOpeningHoursBreaksEnabled, isAvailableDevicesEnabled, isAvailableSticksEnabled);
                    return (_jsx("li", { children: _jsx(StoreLocatorCardV2, { store: store, storeDetailsPageUrl: storeDetailsPageUrl, isListView: true }) }, store.id));
                }) }), hasMoreStores && (_jsx(LoadMore, { className: styles.laodMore, onClick: () => {
                    setPage((page) => page + 1);
                }, label: __("storelocator.show_more") }))] }));
};
//# sourceMappingURL=StoreLocatorMobileList.js.map